var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col float-right" },
        [
          _c(
            "q-btn-group",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.editable && (_vm.completeFlag || !_vm.deleteDisabled),
                  expression: "editable&&(completeFlag||!deleteDisabled)",
                },
              ],
              attrs: { outline: "" },
            },
            [
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.deleteDisabled,
                    expression: "!deleteDisabled",
                  },
                ],
                attrs: { label: "위험성평가 삭제", icon: "remove" },
                on: { btnClicked: _vm.removePlan },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.completeFlag,
                    expression: "completeFlag",
                  },
                ],
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.assessPlan,
                  mappingType: "PUT",
                  label: "평가완료",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completeAction,
                  btnCallback: _vm.completeActionCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        ref: "krasActionTab",
        attrs: { type: "vertical", tabItems: _vm.tabItems, height: _vm.height },
        on: {
          "update:height": function ($event) {
            _vm.height = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    height: _vm.height,
                    process: tab.process,
                    param: _vm.param,
                    planUpdateBtnData: _vm.param.planUpdateBtnData,
                  },
                  on: {
                    "update:process": function ($event) {
                      return _vm.$set(tab, "process", $event)
                    },
                    "update:param": function ($event) {
                      _vm.param = $event
                    },
                    assessComplete: _vm.assessComplete,
                    research: _vm.research,
                    closePopup: _vm.closePopup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }